<h1 mat-dialog-title>
  CHIUSURA ASSEMBLEA
  <mat-icon class="close-icon" (click)="onClose()">close</mat-icon>
</h1>

<h1 class="istruzioni">Decreta Profili Approvati</h1>


<div mat-dialog-content>
  <mat-card class="margin-bottom-10 detail-card mt-15 rounded">

    <mat-card-header>
      <h1 class="card-header"><span class="green">Dati assemblea:</span> {{descrizione}}</h1>

    </mat-card-header>

    <mat-card-content>
      <div class="search-form px-15">

        <mat-form-field class="half-width">
          <mat-label>Data Decreto</mat-label>
          <input matInput [matDatepicker]="dataDecretoPicker" [(ngModel)]="dataDecreto" required>
          <mat-datepicker-toggle matSuffix [for]="dataDecretoPicker"></mat-datepicker-toggle>
          <mat-datepicker #dataDecretoPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="half-width">
          <mat-label>Data Riunione</mat-label>
          <input matInput [matDatepicker]="dataRiunionePicker" [(ngModel)]="dataRiunione" required>
          <mat-datepicker-toggle matSuffix [for]="dataRiunionePicker"></mat-datepicker-toggle>
          <mat-datepicker #dataRiunionePicker></mat-datepicker>
        </mat-form-field>


        <mat-form-field class="half-width">
          <mat-label>Nome Decreto</mat-label>
          <input matInput placeholder="Nome Decreto" [(ngModel)]="nomeDecreto" required>
        </mat-form-field>


        <!--<div class="half-width" *ngIf="!idDocumentoDecreto">
          <div class="file-container" >
            <label for="docAssemblea" class="file-button"><mat-icon class="file-icon">upload</mat-icon>Carica Documento</label>
            <input type="file" id="docAssemblea" (change)="onFileUpload($event)" placeholder="Carica Documento Assemblea" required>
            <p class="file-name-title">{{uploadedFileName}}</p>
          </div>
        </div>

        <div class="half-width" *ngIf="idDocumentoDecreto">
          <mat-form-field>
            <mat-label>Id Documento Decreto</mat-label>
            <input matInput placeholder="Nome Decreto" [(ngModel)]="idDocumentoDecreto" readonly>
          </mat-form-field>
          <button mat-fab extended color="primary" (click)="redoUpload()" class="searchbox-buttons action-button">
            <mat-icon>undo</mat-icon>
            Carica nuovo decreto
          </button>
        </div>-->

      </div>

    </mat-card-content>
  </mat-card>


  <div>
    <mat-card *ngFor="let profile of profiles; index as i;" class="margin-bottom-10 detail-card mt-15 rounded">

      <mat-card-header>
        <h1 class="card-header"><span class="green">{{profile.nomeProfilo}}</span> - {{profile.descrizioneArea.descrizione}}</h1>

        <mat-card-actions class="card-actions">

          <mat-icon color="{{profile.codiceProfilo ? 'accent' : 'warn'}}" matTooltip="{{profile.codiceProfilo ? 'Codice profilo presente' : 'Codice profilo mancante'}}">
            {{profile.codiceProfilo ? 'verified' : 'gpp_bad'}}
          </mat-icon>

        </mat-card-actions>
      </mat-card-header>


      <mat-card-content>
        <div class="px-15">
          <p class="black">STATO PROPOSTA : <span class="green">{{profile.statoProposta.descrizione}}</span></p>
          <p class="black">Codice Profilo : <span [ngClass]="profile.codiceProfilo ? 'green' : 'text-error'">
          {{profile.codiceProfilo ?? 'Non inserito'}}</span>
            <mat-icon *ngIf="!profile.codiceProfilo" [attr.data-index]="i" class="action-icon" matTooltip="Modifica codice profilo" color="primary" (click)="editProfileCode(profile, $event)">
              open_in_new
            </mat-icon>
          </p>

        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div class="dialog-footer">
  <div mat-dialog-actions class="actions">
    <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onClose()">
      <mat-icon>close</mat-icon>
      Annulla
    </button>

    <button mat-fab extended class="searchbox-buttons save-button" (click)="onSubmit()" disabled="{{disableSubmit}}">
      <mat-icon>save</mat-icon>
      Decreta e Pubblica
    </button>

    <!--<button *ngIf="uploadedFile.name" mat-fab extended color="primary" class="searchbox-buttons action-button" (click)="uploadFile()" disabled="{{disableRetryUploadButton}}">
      <mat-icon>upload</mat-icon>
      Riprova caricamento Documento
    </button>-->
  </div>
</div>
